'use client';

import { Content, GroupField } from '@prismicio/client';
import { FC, memo } from 'react';

import { useScreenSize, useVisible } from '@/hooks';

import { Card } from './Card';

import { Simplify } from '../../../../../prismicio-types';
import { ProspectData } from '@/types/salesforce';

import styles from './styles.module.scss';

type Props = {
  cards: GroupField<Simplify<Content.BenefitsSliceDefaultPrimaryCardsItem>>;
  variation:
    | 'default'
    | 'withoutSubtitle'
    | 'lightTheme'
    | 'withoutSubtitleLink'
    | 'engineLanding';
  prospect?: ProspectData;
};

const CardsComponent: FC<Props> = ({ cards, variation, prospect }) => {
  const [isVisibleCard, cardId] = useVisible();
  const screenSize = useScreenSize();

  return (
    <ul className={styles.cards}>
      {cards.map((card, index) => (
        <Card
          cardId={cardId}
          key={card.card_title}
          card={card}
          index={index}
          isVisible={isVisibleCard}
          screenSize={screenSize}
          variation={variation}
          prospect={prospect}
        />
      ))}
    </ul>
  );
};

export const Cards = memo(CardsComponent);
